import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { State } from '../../models/configuration';

@Pipe({ name: 'configState' })
export class ConfigStatePipe implements PipeTransform {
  private translateService = inject(TranslateService);


  transform(value: State): string {
    switch (value) {
      case State.READY:
        return this.translateService.instant('configurations.stateValues.READY');
      case State.SUBMITTED:
        return this.translateService.instant('configurations.stateValues.SUBMITTED');
      default:
        return value;
    }
  }
}
